module.exports = __webpack_public_path__ + "img/galery2.b99e0eb5.jpg";